<template>
  <div class="common-exclusive-service-card">

    <div class="header">
      <img :src="exclusiveData.wwx_avatar || defaultHeaderImage" alt="">
      <p class="name">{{ exclusiveData.cs_name || exclusiveData.bd_name }}</p>
    </div>
    <div class="info">
      <slot name="info"></slot>
    </div>
    <div class="qrcode" v-if="exclusiveData.wx_qrcode">
      <img :src="exclusiveData.wx_qrcode" class="qrcode-img" />
      <div class="weeks">{{ working_time_list[0] }}</div>
      <div class="time">{{ working_time_list[1] }} </div>
    </div>
    <div class="add-btn" @click="$emit('close')">
      已添加
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import defaultHeaderImage from '@/assets/imgs/homepage/fixed-right-service/exclusive-service/default-header.png';

export default {
  props: {
    exclusiveData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      defaultHeaderImage,
    };
  },
  computed: {
    ...mapState('config', [
      'customer_service',
    ]),
    working_time_list() {
      const working_time = this.exclusiveData ? this.exclusiveData.working_time : this.customer_service.working_time;
      const working_time_list = working_time ? working_time.split(' ') : [];
      const work = working_time_list[0];
      working_time_list.splice(0, 1);
      const time = working_time_list.length ? working_time_list.join(' ') : '';
      return [work, time];
    },
  },
};
</script>

<style lang="less" scoped>
.common-exclusive-service-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 0;
  background-color: #fff;
  >div {
    width: 100%;
  }
  .header {
    display: flex;
    flex-direction: column;
    align-items: center;
    >img {
      width: 60px;
      height: 60px;
      border-radius: 50%;
    }
    .name {
      margin-top: 11px;
      font-weight: 600;
      font-size: 20px;
      color: #2F333D;
      line-height: 20px;
      white-space: nowrap;
    }
  }
  .qrcode {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 12px;
    color: #2F333D;
    line-height: 16px;
    .qrcode-img {
      width: 140px;
      height: 140px;
    }
    .weeks {
      margin-top: 8px;
      white-space: nowrap;
    }
    .time {
      white-space: nowrap;
    }
  }
  .add-btn {
    margin-top: 24px;
    width: 240px;
    line-height: 40px;
    background: #599FFF;
    border-radius: 2px;
    text-align: center;
    cursor: pointer;
    font-size: 16px;
    color: #FFFFFF;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/fixed-right-service/components/dialog/exclusive-service-dialog/common-exclusive-service-card.vue